<template>
  <modal
    component-name="modal-gallery"
    :is-open="isOpen" 
    transition="slide-from-bottom"
    @close="emit('close')"
    @open="emit('open')"
    data-skin="skin-light" 
  >
    <div class="flex flex-col items-stretch w-full px-edge">
      <div ref="tpl_wrapper" class="-mx-layout-half py-layout-half">
        <div
          v-for="(item, index) in list"
          :key="index"
          class="masonry-item w-full phablet:w-1/2 laptop:w-1/3 p-layout-half" 
          :class="{
            'desktop:w-1/4': list.length > 12
          }"
        >
          <media
            :variant="item.variant" 
            :aspect-ratio="item.aspectRatio" 
            :width="item.width" 
            :height="item.height"
            :alt="item.alt"
            :src="item.src" 
            :use-parallax="false"
            use-curtain="bottom" 
            :loading="index > 12 ? 'lazy' : 'auto'"
            :class="{
              'grid-sizer': index === 0
            }"
            scroller-class="scrolltrigger-container" 
            :cdn="item.cdn" 
            :sizes="getSizes(item.cdn)"
          />
        </div>
      </div>
    </div>
  </modal>
</template>

<script setup>
const props = defineProps({
  isOpen: {
    type: Boolean,
    reqired: false,
    default: false,
  },
  list: {
    type: Array,
    reqired: true,
  },
});

const emit = defineEmits(["open", "close"]);
const tpl_wrapper = templateRef("tpl_wrapper");
const msnry = ref();

function getSizes(useCdn) {
  let cdnSizes = {
    base: 600,
    phablet: 500,
    tablet: 650,
    laptop: 500,
    desktop: props.list.length > 12 ? 500 : 600,
    extdesktop: props.list.length > 12 ? 650 : 800,
  };

  return useCdn === "cloudinary" ? cdnSizes : undefined;
}

onMounted(() => {
  const { $Masonry } = useNuxtApp();
  watch(
    () => props.isOpen,
    (newVal) => {
      if (newVal) {
        nextTick(() => {
          msnry.value = new $Masonry(tpl_wrapper.value, {
            itemSelector: ".masonry-item",
            percentPosition: true,
            transitionDuration: 0,
            initLayout: false,
          });
          msnry.value.layout();
        });
      }
    }
  );
});

onBeforeUnmount(() => {
  if (msnry.value) {
    msnry.value.destroy();
  }
});
</script>
